import { useInjectReducer } from "@app/store";
import PageHeader from "@components/PageHeader";
import pickupLocationSlice, {
  clearOne,
  setOneValue,
} from "@features/admin/shipping/pickupLocation/pickupLocationSlice";
import { makeSelectOne } from "@features/admin/shipping/pickupLocation/pickupLocationSelector";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PageContent from "@components/PageContent";
import InputWrapper from "@components/Input";
import {
  useAddEditPickupLocationMutation,
  useLoadOnePickupLocationMutation,
} from "@features/admin/shipping/pickupLocation/pickupLocationApiSlice";
import { useEffect } from "react";
import Checkbox from "@components/Checkbox";
import Button from "@components/Button";
import { enqueueSnackbar } from "@features/auth/authSlice";

const PickupLocationAddEditPage = () => {
  useInjectReducer("pickupLocation", pickupLocationSlice);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const one = useSelector(makeSelectOne);

  const [
    onePickupLocation,
    { data: onePickupLocationData, isLoading: loading, isSuccess: success },
  ] = useLoadOnePickupLocationMutation();
  const [savePickupLocation, { isLoading: saveLoading }] =
    useAddEditPickupLocationMutation();

  useEffect(() => {
    if (id) {
      onePickupLocation(id);
    } else {
      dispatch(clearOne());
    }
  }, []);

  const handleCheckedChange = (name) => (event) => {
    dispatch(setOneValue({ key: name, value: event.target.checked }));
  };

  const handleChange = (name) => (event) => {
    dispatch(setOneValue({ key: name, value: event.target.value }));
  };

  const handleSave = () => {
    const body = { ...one };
    savePickupLocation(body)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(
            enqueueSnackbar({
              message: res?.msg ?? "Pickup Location Added Successfully.",
              options: {
                variant: "success",
              },
            })
          );
          navigate("/admin/pickup");
          dispatch(clearOne());
        }
      })
      .catch((err) => {
        if (err?.data?.msg) {
          dispatch(
            enqueueSnackbar({
              message: err?.data?.msg ?? "Pickup Location Add Failed",
              options: {
                variant: "warning",
              },
            })
          );
        }
      });
  };

  return (
    <>
      <Helmet>
        <title> {id ? `Edit` : `Add`} Location </title>
      </Helmet>
      <PageHeader
        title={id ? `Edit Pickup Location` : `Add Pickup Location`}
        isBack
        handleGoBack={() => navigate("/admin/pickup")}
      />
      <PageContent>
        <div className="bg-white p-4 border">
          <div className="w-full md:w-1/2 pb-4">
            <InputWrapper
              label="Title"
              id="grid-title"
              name="title"
              type="text"
              value={one?.title || ""}
              onChange={handleChange("title")}
            />
          </div>
          <div className="w-full md:w-1/2 pb-4">
            <InputWrapper
              label="Location"
              id="grid-location"
              name="location"
              type="text"
              value={one?.location || ""}
              onChange={handleChange("location")}
            />
          </div>
          <div className="w-full md:w-1/2 pb-4">
            <InputWrapper
              label="Mobile Number"
              id="grid-mobile-number"
              name="mobile-number"
              type="text"
              value={one?.mobile || ""}
              onChange={handleChange("mobile")}
            />
          </div>
          <div className="w-full md:w-1/2 pb-4">
            <Checkbox
              label="Is Active"
              name="is_active"
              onChange={handleCheckedChange("is_active")}
              checked={one?.is_active || false}
            />
          </div>
          <div className="mt-4">
            <Button onClick={handleSave} loading={saveLoading}>
              Save
            </Button>
          </div>
        </div>
      </PageContent>
    </>
  );
};

export default PickupLocationAddEditPage;
